import { type CarrierDef } from '../common.js'
import { hjbt, type hjbtCredType } from './hjbt.js'

export type hjbiCredType = hjbtCredType
export const hjbi: CarrierDef<hjbiCredType> = {
  ...hjbt,
  scac: 'hjbi',
}
